<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :questions="questions"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import HomeInsuranceData from '@/data/company-page-data/bereket-sigorta/cross-pages/HomeInsurance'
export default {
  metaInfo: {
    title: 'Bereket Sigorta Konut Sigortası Hesaplama, Teklif Alma',
    meta: [
      {
        name: 'description',
        content: 'Bereket Sigorta Konut (Ev) Sigortası kapsamını öğrenmek için teklif al formunu doldurun. Merak ettiğiniz tüm detayları uzmanlarımıza sorun.'
      }
    ]
  },
  name: 'BereketSigortaHomeInsurance',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: HomeInsuranceData.headerContent,
      crossPageContent: HomeInsuranceData.crossPageContent,
      faqTitle: HomeInsuranceData.faqTitle,
      faqTitleDesc: HomeInsuranceData.faqTitleDesc,
      questions: HomeInsuranceData.questions
    }
  }
}
</script>
